export default "__VITE_ASSET__e43248bf__"